














































import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";

export default Vue.extend({
  data() {
    return {
      showSnackbar: false,
      snackbarColor: "",
      snackbarText: "",
      email: "",
      password: "",
      loading: false,
      emailRules: [
        (v: string) => !!v || "E-mail is required",
        (v: string) => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        (v: string) => !!v || "Password is required",
        (v: string) =>
          (v && v.length >= 6) || "Password must be at least 6 characters"
      ]
    };
  },
  methods: {
    signIn() {
      if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        return;
      }
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          console.log("signed in with user: ", user);
          this.loading = false;
          this.$store.commit("updateFirebaseUser", user);
          router.push({ name: "Blogs" });
        })
        .catch(error => {
          this.loading = false;
          this.showSnackbar = true;
          this.snackbarText = error;
          this.snackbarColor = "error";
        });
    }
  }
});
